import { ComponentFactoryResolver, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, interval, of, Subject } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from '@ml/auth/services';
import { AppBarService } from '@ml/shared/services/app-bar.service';
import strings from '../../../../assets/i18n/strings';
import { SidenavService, UserService } from '@ml/core/services';
import { UserRole } from '@ml/core/types/enums';
import { NotificationsComponent } from '@ml/notifications/containers';
import { NotificationsService } from '@ml/notifications/services';
import { catchError, distinctUntilChanged, filter, first, map, startWith, switchMap, takeUntil } from 'rxjs/operators';
import { ConnectionService } from '@ml/core/services/connection.service';
import { TaskLogsService } from '@ml/tasks/services';
import { PushNotificationsService } from '@ml/core/services/push-notifications.service';
var MainLayoutComponent = /** @class */ (function () {
    function MainLayoutComponent(router, authService, appBarService, userService, sidenavService, componentFactoryResolver, notificationsService, connectionService, taskLogsService, pushNotificationsService) {
        this.router = router;
        this.authService = authService;
        this.appBarService = appBarService;
        this.userService = userService;
        this.sidenavService = sidenavService;
        this.componentFactoryResolver = componentFactoryResolver;
        this.notificationsService = notificationsService;
        this.connectionService = connectionService;
        this.taskLogsService = taskLogsService;
        this.pushNotificationsService = pushNotificationsService;
        this.connection = true;
        this.ngUnsubscribe = new Subject();
        this.VAPID_PUBLIC_KEY = 'BBrWw53KJ7FMEBJ4v0kxJmsWQjS7dS_EGlY6LpBFl2JeBv3QV68axZZrRsZ4stjqh9mJw5cq0XGt3g51QpRNslY';
    }
    MainLayoutComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.initNotificationsPooling();
        this.connectionService.connection$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (value) { return (_this.connection = value); });
        this.connectionService.connection$
            .pipe(distinctUntilChanged(), filter(function (value) { return value; }), switchMap(function () { return _this.taskLogsService.submitCachedLogs(); }), switchMap(function () { return _this.taskLogsService.list(); }))
            .subscribe(function (value) { });
        this.user = this.userService.user;
        this.initSidebarOptions();
        this.currentRoute$ = new BehaviorSubject(this.router.routerState.root.snapshot);
        this.setAppBarTitle();
        this.router.events.subscribe(function (event) {
            if (event instanceof NavigationEnd) {
                _this.setAppBarTitle();
                _this.currentRoute$.next(_this.router.routerState.root.snapshot);
            }
        });
        this.pushNotificationsService
            .subscribeChangeToken$()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe();
        this.pushNotificationsService
            .requestPermission$()
            .pipe(first())
            .subscribe();
    };
    MainLayoutComponent.prototype.onLogOut = function () {
        var _this = this;
        this.userService.setFCMToken(null).subscribe(function () {
            _this.authService.logout();
            _this.router.navigate(['auth']);
        });
    };
    MainLayoutComponent.prototype.onOpenNotifications = function () {
        var componentFactory = this.componentFactoryResolver.resolveComponentFactory(NotificationsComponent);
        this.unreadNotifications = false;
        this.sidenavService.open(componentFactory);
    };
    MainLayoutComponent.prototype.initNotificationsPooling = function () {
        var _this = this;
        var poolingInterval = 150000;
        interval(poolingInterval)
            .pipe(takeUntil(this.ngUnsubscribe), startWith(1), filter(function () { return _this.connectionService.connection; }), switchMap(function () { return _this.notificationsService.unreadNotifications(); }), catchError(function (err) { return of(null); }), map(function (value) { return value || 0; }))
            .subscribe(function (value) { return (_this.unreadNotifications = value > 0); });
    };
    MainLayoutComponent.prototype.setAppBarTitle = function () {
        var _this = this;
        var url = this.router.url;
        this.active = url.split('/')[1].split('?')[0];
        var option = this.sidenavOptions.find(function (value) { return value.routerLink === _this.active; });
        this.appBarService.titleAppBar.subscribe(function (value) {
            if (value) {
                _this.tabBarTitle = value;
            }
            else {
                _this.tabBarTitle = option ? option.name : 'Dashboard';
            }
        });
    };
    MainLayoutComponent.prototype.initSidebarOptions = function () {
        var _this = this;
        var options = [
            {
                name: strings.orders,
                icon: 'assignment',
                routerLink: 'orders',
                role: [UserRole.ADMIN]
            },
            {
                name: strings.customers,
                icon: 'domain',
                routerLink: 'customers',
                role: [UserRole.ADMIN]
            },
            {
                name: 'suppliers',
                icon: 'archive',
                routerLink: 'suppliers',
                role: [UserRole.ADMIN]
            },
            {
                name: strings.machinery,
                icon: 'build',
                routerLink: 'machineries',
                role: [UserRole.ADMIN]
            },
            {
                name: strings.services,
                icon: 'settings',
                routerLink: 'services',
                role: [UserRole.ADMIN]
            },
            {
                name: 'tasks',
                icon: 'assignment_turned_in',
                routerLink: 'tasks',
                role: [UserRole.ADMIN, UserRole.EMPLOYEE]
            },
            {
                name: strings.accounting,
                icon: 'insert_chart',
                routerLink: 'accounting',
                role: [UserRole.ADMIN]
            },
            {
                name: strings.employees,
                icon: 'people',
                routerLink: 'employees',
                role: [UserRole.ADMIN]
            },
            {
                name: 'salaries',
                icon: 'salaries',
                routerLink: 'salaries',
                role: [UserRole.ADMIN, UserRole.EMPLOYEE]
            },
            {
                name: strings.orders,
                icon: 'assignment',
                routerLink: 'customer-orders',
                role: [UserRole.CUSTOMER]
            },
            {
                name: 'locations',
                icon: 'location',
                routerLink: 'locations',
                role: [UserRole.CUSTOMER]
            }
        ];
        this.sidenavOptions = options.filter(function (option) { return option.role.indexOf(_this.user.role) >= 0; });
    };
    Object.defineProperty(MainLayoutComponent.prototype, "isCustomer", {
        get: function () {
            return this.user.role === UserRole.CUSTOMER;
        },
        enumerable: true,
        configurable: true
    });
    MainLayoutComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    return MainLayoutComponent;
}());
export { MainLayoutComponent };
